import { render, staticRenderFns } from "./LvNumberStepper.vue?vue&type=template&id=80c1d6f2"
import script from "./LvNumberStepper.vue?vue&type=script&lang=js"
export * from "./LvNumberStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports